import React from "react";
import {useDispatch} from "react-redux";
import {Avatar, Popover} from "antd";
import {userSignOut} from "appRedux/actions/Auth";
import avatarImage from "../../assets/images/avatar.jpg";

const UserInfo = () => {

  const dispatch = useDispatch();

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>My Account</li>
      <li>Connections</li>
      <li onClick={() => dispatch(userSignOut())}>Logout
      </li>
    </ul>
  );

  return (
    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={userMenuOptions}
             trigger="click">
      <Avatar src={avatarImage}
              className="gx-avatar gx-pointer" 
              alt="User Avatar"
              onError={(e) => {
                console.error('Avatar failed to load:', e);
                return false;
              }}
              size={40}/>
    </Popover>
  )

}

export default UserInfo;
